import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarUserStateSchema } from '../schemas';

const saveGrammarSessionV1DataSchemaDefinition = z.object({
  states: z.array(grammarUserStateSchema),
});

export const saveGrammarSessionV1DataSchema: typeof saveGrammarSessionV1DataSchemaDefinition =
  saveGrammarSessionV1DataSchemaDefinition;

export type ISaveGrammarSessionV1Data = z.infer<typeof saveGrammarSessionV1DataSchema>;

export const saveGrammarSessionV1ResponseSchema: z.ZodSchema<IAPI<ISaveGrammarSessionV1Data>> =
  createApiResponseSchema(saveGrammarSessionV1DataSchema) as z.ZodSchema<
    IAPI<ISaveGrammarSessionV1Data>
  >;

export type ISaveGrammarSessionV1Response = IAPI<ISaveGrammarSessionV1Data>;
